// Import model
import { UpdateSfLeadRequest } from '../models/UpdateSfLeadRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateSfLeadRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateSfLeadRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateSfLeadRequest instance
   */
  static deserialize(json: string): UpdateSfLeadRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateSfLeadRequest instance
   */
  static fromObject(obj: any): UpdateSfLeadRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateSfLeadRequest');
    }


    const instance: UpdateSfLeadRequest = {
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateSfLeadRequest instances
   */
  static deserializeArray(json: string): UpdateSfLeadRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateSfLeadRequest instance to a JSON string
   */
  static serialize(instance: UpdateSfLeadRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateSfLeadRequest instance to a plain object
   */
  static toObject(instance: UpdateSfLeadRequest): any {
    return {
    };
  }

  /**
   * Serializes an array of UpdateSfLeadRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateSfLeadRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
